/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    assetEchartsCompanyId: {},
    assetEchartsAnlkl: {},
    activeTabs: null,

  },
  getters: {
    assetEchartsCompanyId: state => state.assetEchartsCompanyId,
    assetEchartsAnlkl: state => state.assetEchartsAnlkl,
    activeTabs: state => state.activeTabs
  },
  mutations: {
    assetEchartsCompanyId: (state, data) => {
      state.assetEchartsCompanyId = data
    },
    assetEchartsAnlkl: (state, data) => {
      state.assetEchartsAnlkl = data
    },
    activeTabs: (state, data) => {
      state.activeTabs = data
    }
  },
  actions: {
    handleAssetEchartsCompanyId (assetEchartsCompanyId, data) {
      assetEchartsCompanyId.commit('assetEchartsCompanyId', data)
    },
    handleAssetEchartsAnlkl (assetEchartsAnlkl, data) {
      assetEchartsAnlkl.commit('assetEchartsAnlkl', data)
    },
    handleActiveTabs (assetEchartsAnlkl, data) {
      assetEchartsAnlkl.commit('activeTabs', data)
    }
  }
}
